import { render, staticRenderFns } from "./ServerExcelReasonLayerPopup.vue?vue&type=template&id=61f12d1c&"
import script from "./ServerExcelReasonLayerPopup.vue?vue&type=script&lang=ts&"
export * from "./ServerExcelReasonLayerPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports